import React, { FC } from 'react';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import { CommodityResponseDto } from '../../../store/tradeAPI/commodity/dto/response/commodity-response.dto';

interface LandscapeProjectsAddProjectsImpactCommodityOrganismProps {
  data: CommodityResponseDto[];
  handleDelete: (id: string) => void;
  handleEdit: (id: string) => void;
}

const LandscapeProjectsAddProjectsImpactCommodityOrganism: FC<
  LandscapeProjectsAddProjectsImpactCommodityOrganismProps
> = ({ data, handleDelete, handleEdit }) => {
  return (
    <SortableTable
      data={data}
      columns={[{ label: 'Commodity', key: 'name' }, { label: '' }]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name} />
          <Action
            type="delete"
            size="sm"
            onClick={() => {
              handleDelete(row.id);
            }}
          ></Action>
          <Action
            type="edit"
            size="sm"
            onClick={() => {
              handleEdit(row.id);
            }}
          ></Action>
        </TableRow>
      )}
      showEditButtonHeader={false}
    />
  );
};

export default LandscapeProjectsAddProjectsImpactCommodityOrganism;
